var React = require('react');

function Ml (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"red","d":"M425.8 0H640v480H425.7z","key":0}),React.createElement("path",{"fill":"#009a00","d":"M0 0h212.9v480H0z","key":1}),React.createElement("path",{"fill":"#ff0","d":"M212.9 0h214v480h-214z","key":2})]));
}

Ml.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ml;

Ml.default = Ml;
